/* eslint-disable import/prefer-default-export */
import { watch } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { replace } from '@/locales/i18n';
import { locales, locale as defaultLocale, url } from '@/config/site';
import { createCanonicalLink, createI18nLink, setAttribute } from '@/utils/element';
import { useSymbol } from '@/hooks/exchange';

// 针对SEO，语言做特殊处理；
const LOCALES_SPECIAL = ['es-419', 'fil-PH'];

const localeSpecialHandler = (locale) => {
    if (LOCALES_SPECIAL.includes(locale)) {
        if (locale === 'fil-PH') {
            return 'tl';
        }
        return locale.split('-')[0];
    }
    return locale;
};

export function useSEO() {
    const route = useRoute();
    const { locale, t } = useI18n({ useScope: 'global' });
    const symbol = useSymbol();

    watch([
        () => locale.value,
        () => symbol.value,
        () => route.meta,
    ], ([localeVal, symbolVal]) => {
        if (window.sfe.prerender && localeVal) {
            setAttribute('html', 'lang', localeSpecialHandler(localeVal));
        }
        if (route.meta.ogdescription) {
            const description = t(route.meta.ogdescription, { symbol: symbolVal.symbolName });
            setAttribute('meta[name="description"]', 'content', description);
            setAttribute('meta[property="og:description"]', 'content', description);
            setAttribute('meta[property="twitter:description"]', 'content', description);
        }
        if (route.meta.ogtitle) {
            const title = t(route.meta.ogtitle, { symbol: symbolVal.symbolName });
            setAttribute('meta[property="og:title"]', 'content', t(title));
            setAttribute('meta[property="twitter:title"]', 'content', t(title));
        }
        if (route.meta.title) {
            document.title = t(route.meta.title);
        }
    });

    watch([
        () => locale.value,
        () => route.path,
    ], () => {
        const { pathname } = window.location;

        // 添加 en-IN 特殊处理，用于“谷歌搜索 Bybit 排名优化 （IN 地区）” 的需求。
        // locales.push('en-IN');
        // locales.forEach((key) => {
        //     if (key !== 'zh-CN') {
        //         /**
        //          * 修正 en-IN 为 en，用于修正 pathname 中的语言
        //          */
        //         let innerKey = key;
        //         let innerURL = url;
        //         if (key === 'en-IN') {
        //             innerKey = 'en';
        //             innerURL = 'https://www.bybitglobal.com';
        //         }

        //         const localePathname = replace(pathname, innerKey);
        //         createI18nLink({ locale: localeSpecialHandler(key), href: `${innerURL}${localePathname}` });
        //     }
        // });
        const defaultLanguageLink = `${url}${replace(pathname, defaultLocale)}`;
        const currentPageLink = `${url}${pathname}`;
        // createI18nLink({ locale: 'x-default', href: defaultLanguageLink });
        createCanonicalLink(currentPageLink);
        setAttribute('meta[property="og:url"]', 'content', currentPageLink);
    });
}
